import { render, staticRenderFns } from "./summary-sales-by-product.vue?vue&type=template&id=94c481de&scoped=true&"
import script from "./summary-sales-by-product.vue?vue&type=script&lang=js&"
export * from "./summary-sales-by-product.vue?vue&type=script&lang=js&"
import style0 from "./summary-sales-by-product.vue?vue&type=style&index=0&id=94c481de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c481de",
  null
  
)

export default component.exports